import React, { ReactNode, useContext, useState, useEffect } from 'react';
import { useWindowWidth } from '@react-hook/window-size';

const breakpoints = {
    sm: 768,
    md: 1024,
    // lg: 1400,
    // xl: 1800
};

interface BreakpointContextProps {
    // xl: boolean;
    // lg: boolean;
    md: boolean;
    sm: boolean;
    xs: boolean;
}

const BreakpointContext = React.createContext({} as BreakpointContextProps);

interface BreakpointProviderProps {
    children: ReactNode;
}

export function BreakpointProvider({ children }: BreakpointProviderProps) {
    const width = useWindowWidth();

    const [breakpointsState, setBreakpointsState] = useState({
        // xl: width >= breakpoints.xl,
        // lg: width >= breakpoints.lg && width < breakpoints.xl,
        md: width >= breakpoints.md, // && width < breakpoints.lg,
        sm: width >= breakpoints.sm && width < breakpoints.md,
        xs: width < breakpoints.sm,
    });

    useEffect(() => {
        setBreakpointsState({
            // xl: width >= breakpoints.xl,
            // lg: width >= breakpoints.lg && width < breakpoints.xl,
            md: width >= breakpoints.md, // && width < breakpoints.lg,
            sm: width >= breakpoints.sm && width < breakpoints.md,
            xs: width < breakpoints.sm,
        });
    }, [width]);

    return (
        <BreakpointContext.Provider value={breakpointsState}>
            {children}
        </BreakpointContext.Provider>
    );
}

export const useBreakpointContext = () => useContext(BreakpointContext);
